
const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteComandaIngredients = async (  id_comanda : number, page : string, id_usu_log: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comanda/ingredients/${id_comanda}/${id_usu_log}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
